import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Dashboard from '@/components/Dashboard.vue'
import Login from "@/components/Login.vue";
import validateLoginGuard from "@/router/validateLogin.guard"
import InstrumentosList from "@/components/Instrumentos/List.vue"
import UsersList from "@/components/Users/List.vue"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
		beforeEnter: validateLoginGuard
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
		beforeEnter: validateLoginGuard,
    children: [
      { path: 'instrumentos', name: 'InstrumentosList', component: InstrumentosList, meta: { title: 'Instrumentos' } },
      { path: 'users', name: 'UsersList', component: UsersList, meta: { title: 'Usuarios' } },
    ]
  },
	{
		path: '/',
		redirect: '/login'
	}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
